import PropTypes from 'prop-types';
import './LoadingOverlay.css';

const LoadingOverlay = ({ message }) => {
  return (
    <div className="loading-overlay">
      <div className="loading-overlay-spinner">
        <i className="fa fa-spinner fa-spin fa-2x"></i>
      </div>
      <div className="loading-overlay-text">
        {message}
      </div>
    </div>
  );
};

LoadingOverlay.propTypes = {
  message: PropTypes.string,
};

export default LoadingOverlay;
